// This file maps state to stores, and also exposes a fetchData function to fetch all
// the data needed to render the smart component
import CommonStore from '@src/stores/CommonStore';
import ActionStore from '@src/ActionStore';
import BotStore from '@src/store';
import BusinessStore from '@src/stores/BusinessStore';

/**
 * These are the stores the container will subscribe to, the getStateFromStores()
 * below runs again if the stores mentioned here emit a change
 * @type {Array}
 */
export const listenToStores = [
  CommonStore,
  ActionStore,
  BotStore,
  BusinessStore,
];

/**
 * Maps objects from the store to the local container
 * We fetch different values from the various stores and then assign them
 * here so that they're available as props to the container component
 * @return {[type]} [description]
 */
export function getStateFromStores() {
  const metatags = CommonStore.getMetaTags();
  return {
    // meta info
    domain: metatags.domain,
    story: metatags.story,
    subStory: metatags.subStory,
    step: metatags.step,
    meta: metatags,
    allLanguages: CommonStore.getAllLanguages(),
    supportedLanguages: CommonStore.getSupportedLanguages(),
    currentLanguage: CommonStore.getCurrentLanguage(),
    currentScreen: CommonStore.getCurrentScreen(),
    headerData: ActionStore.getHeaderData(),
    permissions: BotStore.getPermissions(),
    storyMeta: BotStore.getAllStoriesMeta()
    // businessName: BusinessStore.getBusinessData().name,
  };
}

export { updateCurrentLanguage } from 'actions/LanguageActions';
export {
  confirmTransferBot,
  confirmDeployBot,
  confirmExtractBot,
  logout,
  openComponentModal,
  closeComponentModal,
} from 'actions/BotActions';
